import { useSearchV1, useSearchV3 } from './useSearch'

export const search = {
  search: {
    v1: useSearchV1,
    v3: useSearchV3,
  },
}
